import {FC} from 'react';
import clsx from 'clsx';

export type StringValueProps = {
    className?: string;
    value: string;
};

const StringValue: FC<StringValueProps> = ({className, value}) => (
    <div className={clsx('whitespace-pre-wrap break-words', className)}>
        {value}
    </div>
);

export default StringValue;
